import React from 'react';
import PropTypes from "prop-types";

import {styled} from "@mui/material/styles";

import {ReactComponent as ArrowRight} from "assets/img/arrow-right.svg";
import {greyishBlue300} from "assets/jss/main";

ArrowRightIcon.propTypes = {
    color: PropTypes.string,
    disabled: PropTypes.bool,
    size: PropTypes.number,
};

const StyledSvg = styled(ArrowRight)(({ theme, color, disabled, size}) => ({
    ...size && {
        width: size,
        height: size
    },
    'path': {
        ...color !== null && {
            fill: color
        },
        ...disabled === true &&  {
            fill: greyishBlue300
        }
    },
}));

export default function ArrowRightIcon(props) {
    return <StyledSvg {...props} />;
}
